import { Box } from '@zillow/constellation-10';

import { LoadingHeading } from '@zg-rentals/loading-components';
import { UpcomingTours } from '@zg-rentals/touring';
import { useZCalendarWebApiHandler_getTouringTreatmentForZuidAndListing } from '@zg-rentals/ts-z-calendar-client-react-query';

import { useScreenSize } from '../../../../hooks/useScreenSize';

import { getTourCalendarRoute } from '../../../../constants/urls';

import { useAuth } from '../../../../components/AuthProvider';

import {
  emitUpcomingToursMoreToursCtaEvent,
  UPCOMING_TOURS_MORE_TOURS_CTA_EVENT_ID,
} from '../../../../analytics/events/overviewPage';
import ConnectedModuleCard from '../../../ConnectedModuleCard';

type Props = {
  listingAlias: string;
  isActive: boolean;
};

const UpcomingToursModule = ({ listingAlias, isActive }: Props) => {
  const { user } = useAuth();
  const { isScreenMobile } = useScreenSize();

  const inquiriesPath = `/rental-manager/lead-management/${listingAlias}`;
  const { pathname: tourCalendarPathname } = getTourCalendarRoute({ listingAlias });
  const tourCalendarPath = `/rental-manager${tourCalendarPathname.replace('[listingAlias]', listingAlias)}`;

  const { data: touringTreatment, isLoading: isGetTouringTreatmentLoading } =
    useZCalendarWebApiHandler_getTouringTreatmentForZuidAndListing(
      { listingAlias },
      { enabled: Boolean(listingAlias) },
    );

  const onCalendarClick = () => {
    if (user) {
      emitUpcomingToursMoreToursCtaEvent({ currentProperty: { listingAlias }, user });
    }
  };

  return (
    <>
      {isGetTouringTreatmentLoading ? (
        <Box css={{ marginBottom: '400' }}>
          <ConnectedModuleCard
            isLoading={isGetTouringTreatmentLoading}
            css={{
              borderRadius: { base: 0, xxl: 'Card.Root' },
            }}
          >
            <LoadingHeading level={2} isLoading={isGetTouringTreatmentLoading} loadingWidth="100%">
              Upcoming Tours
            </LoadingHeading>
          </ConnectedModuleCard>
        </Box>
      ) : (
        touringTreatment &&
        touringTreatment.isTouringEnabledForListing &&
        (isActive || touringTreatment.hasBookedTours) && (
          <Box css={{ marginBottom: '400' }}>
            <ConnectedModuleCard
              css={{
                borderRadius: { base: 0, xxl: 'Card.Root' },
              }}
            >
              <UpcomingTours
                inquiriesPath={inquiriesPath}
                isScreenMobile={isScreenMobile}
                listingAlias={listingAlias}
                onCalendarClick={onCalendarClick}
                tourCalendarPath={tourCalendarPath}
                eventId={UPCOMING_TOURS_MORE_TOURS_CTA_EVENT_ID}
              />
            </ConnectedModuleCard>
          </Box>
        )
      )}
    </>
  );
};

export default UpcomingToursModule;
